export default {
  name: "BDDM",
  components: {},
  props: ["selected", "items", "hide"],
  data() {
    return {};
  },
  beforeDestroy() {},
  computed: {
    checkedItems: function() {
      if (this.hide) {
        return this.items.filter((x, index) => this.hide.indexOf(index) === -1);
      }

      return this.items;
    }
  },
  created() {
    if (!this.selected) {
      this.$emit("selected", 0);
    }
  },
  mounted() {},
  methods: {
    Select(index) {
      this.$emit("selected", index);
    }
  }
};
